import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-blog-post-list',
  templateUrl: './blog-post-list.component.html',
  styleUrls: ['./blog-post-list.component.scss']
})
export class BlogPostListComponent implements OnInit {
  @Input() posts: any[];
  constructor() { }

  ngOnInit(): void {
  }

}
